import React from "react"
import autobind from "class-autobind"
import { EScheduleListType, IClientDocument, IJobDocument, IScheduleDocument } from "../../../models"
import strings from "../../../localization/strings"
import { TextField, Paper, IconButton, Toggle, RaisedButton, FontIcon } from "material-ui"
import { grey100, grey600, grey800 } from "material-ui/styles/colors"
import moment from "moment"
import * as permissionHelper from "../../../helpers/permissionHelper"
import AuthenticationStore from "../../../stores/AuthenticationStore"
import Copy from "../../../../assets/icons/copy"
import * as utils from "../../../helpers/utils"
import * as timeHelper from "../../../helpers/timeHelper"
import * as scheduleHelper from "../../../helpers/scheduleHelper"
import AppStateStore from "../../../stores/AppStateStore"
import * as reportAction from "../../../actions/ReportAction"
import AccountStore from "../../../stores/AccountStore"
import ChooseClientChip from "../../clients/choose_client/ChooseClientChip"
import ScheduleBudgetDetail from "./ScheduleBudgetDetail"
import ChooseHierarchyJobChip from "../../hierarchy/choose_hierarchy/ChooseHierarchyJobChip"
import * as api from "../../../api"
import _ from "lodash"
import { checkJobFieldAvailable } from "../../../helpers/jobHelper"

interface IProps {
  type: EScheduleListType
  readonly: boolean
  schedule: IScheduleDocument
  selectedClient: IClientDocument
  selectedJob: IJobDocument
  handleCopySchedule(): void
  handleAutoAssign(): void
  handleUpdateSchedule(schedule: IScheduleDocument): Promise<boolean>
  handlePostMasterScheduleForCurrentWeek(): void
}
interface IState {
  name: string
  errorName: string
  description: string
  hierarchyId: string
  job: IJobDocument
  client: IClientDocument
  masterScheduleActive: boolean
  masterScheduleInAdvanceDays: number
  errorMasterScheduleInAdvanceDays: string
  excludeWeekends: boolean
  autoPostAsSchedulePlanner: boolean
}

export default class ScheduleInfoDetail extends React.Component<IProps, IState> {
  constructor(props) {
    super(props)
    this.state = {
      name: this.props.schedule.Name,
      errorName: "",
      description: this.props.schedule.Description,
      hierarchyId: this.props.schedule.HierarchyId,
      job: null,
      client: null,
      masterScheduleActive: this.props.schedule.MasterScheduleActive,
      masterScheduleInAdvanceDays: this.props.schedule.InAdvanceDays,
      errorMasterScheduleInAdvanceDays: "",
      excludeWeekends: this.props.schedule.ExcludeWeekends,
      autoPostAsSchedulePlanner: this.props.schedule.AutoPostAsPlanner
    }
    autobind(this)
  }

  componentDidMount() {
    this.getClientJobData(this.props.schedule.ClientId, this.props.schedule.JobId)
  }

  getClientJobData(clientId: string, jobId: string) {
    clientId &&
      api.getClient(clientId).then(res =>
        this.setState({ client: res.data })
      )
    jobId &&
      api.getJob(jobId).then(res =>
        this.setState({ job: res.data })
      )
  }

  checkValidate() {
    let isValidate = true
    if (this.state.name.trim() === "") {
      this.setState({ errorName: strings.This_field_is_required })
      isValidate = false
    }
    else {
      this.setState({ errorName: "" })
    }

    if (this.props.schedule.MasterSchedule) {
      if (!this.state.masterScheduleInAdvanceDays) {
        this.setState({ errorMasterScheduleInAdvanceDays: strings.This_field_is_required })
        isValidate = false
      }
      else if (Number(this.state.masterScheduleInAdvanceDays) < 1) {
        this.setState({ errorMasterScheduleInAdvanceDays: strings.formatString(strings.This_field_must_be_greater_than_or_equal_to_x, 1) as string })
        isValidate = false
      }
      else {
        this.setState({ errorMasterScheduleInAdvanceDays: "" })
      }
    }
    return isValidate
  }

  handleUpdate() {
    const schedule = _.cloneDeep(this.props.schedule)
    const name = this.state.name
    const description = this.state.description
    const hierarchyId = this.state.hierarchyId
    const jobId = this.state.job ? this.state.job.Id : null
    const clientId = this.state.client ? this.state.client.Id : null
    const excludeWeekends = this.state.excludeWeekends
    if (
      schedule.Name === name &&
      schedule.Description === description &&
      schedule.HierarchyId === hierarchyId &&
      schedule.JobId === jobId &&
      schedule.ClientId === clientId &&
      schedule.ExcludeWeekends === excludeWeekends &&
      schedule.MasterScheduleActive === this.state.masterScheduleActive &&
      schedule.InAdvanceDays === this.state.masterScheduleInAdvanceDays &&
      schedule.AutoPostAsPlanner === this.state.autoPostAsSchedulePlanner
    ) return
    if (!this.checkValidate()) return

    const originalSchedule = _.cloneDeep(schedule)
    schedule.Name = name
    schedule.Description = description
    schedule.HierarchyId = hierarchyId
    schedule.JobId = jobId
    schedule.JobName = this.state.job ? this.state.job.Name : null
    schedule.ClientId = clientId
    schedule.ExcludeWeekends = this.state.excludeWeekends

    if (schedule.MasterSchedule) {
      schedule.MasterScheduleActive = this.state.masterScheduleActive
      schedule.InAdvanceDays = this.state.masterScheduleInAdvanceDays
      schedule.AutoPostAsPlanner = this.state.autoPostAsSchedulePlanner
    }

    this.props.handleUpdateSchedule(schedule).then(res => {
      if (!res) {
        this.setState({
          name: originalSchedule.Name,
          errorName: "",
          description: originalSchedule.Description,
          hierarchyId: originalSchedule.HierarchyId,
          job: null,
          client: null,
          masterScheduleActive: originalSchedule.MasterScheduleActive,
          masterScheduleInAdvanceDays: originalSchedule.InAdvanceDays,
          errorMasterScheduleInAdvanceDays: "",
          excludeWeekends: originalSchedule.ExcludeWeekends,
          autoPostAsSchedulePlanner: originalSchedule.AutoPostAsPlanner
        }, () => this.getClientJobData(originalSchedule.ClientId, originalSchedule.JobId))
      }
    })
  }

  getStaffingInfoLabelColumn(label, number) {

    if (number && number > 0) {
      return <div style={{ gridRow: "auto", gridColumn: 1, paddingRight: 10 }}><b>{label}: </b></div>
    }
  }

  getStaffingInfoValueColumn(number) {
    if (number && number > 0) {
      return <div style={{ gridRow: "auto", gridColumn: 2 }}>{Math.round(100 * number)}%</div>
    }
  }

  saveChanging = _.debounce(() => this.handleUpdate(), 1000)

  render() {
    const now = moment()
    const periodDays = scheduleHelper.getDayLengthFromStartAndEndTime(this.props.schedule.StartDate, this.props.schedule.EndDate)
    const showImmediatelyPostBtn = this.props.schedule.Schedules.filter(i => !i.Deleted).length > 0 &&
      moment(timeHelper.keepConvertUTCToLocal(this.props.schedule.StartDate)).isSameOrBefore(now) &&
      now.isSameOrBefore(timeHelper.keepConvertUTCToLocal(this.props.schedule.EndDate))
    return (
      <Paper zDepth={1} style={{ textAlign: "left", margin: 20, position: "relative", overFlow: "hidden" }}>
        <div style={{ display: "flex" }}>
          <div style={{ display: "flex", flexDirection: "column", flex: 1, textAlign: "center" }}>
            {this.props.schedule.MasterSchedule ?
              <div>
                <div style={{ fontSize: 23, fontWeight: 600, marginTop: showImmediatelyPostBtn ? 45 : 60, position: "relative" }}>
                  {strings.Master_schedule}
                  <FontIcon
                    data-intercom-target={"master-schedule-NotesAndAudit"}
                    className="fa fa-info-circle"
                    style={{ fontSize: 16, right: 8, top: -5, color: "#777777", cursor: "pointer", position: "absolute" }}
                    onTouchTap={() => AppStateStore.setNoteDrawerContent({
                      drawerTitle: `${this.props.schedule.Name}`,
                      objectData: {
                        ObjectId: this.props.schedule.Id
                      },
                      objectName: `MasterSchedule ${this.props.schedule.Name}`,
                      dataType: "shift",
                    })}
                  />
                </div>
                <Toggle
                  data-intercom-target={"menu-Schedules-ScheduleInfo-Toggle-MasterScheduleActive"}
                  disabled={this.props.readonly}
                  label={strings.Master_Schedule_Active}
                  toggled={this.state.masterScheduleActive}
                  style={{ width: 200, marginTop: 20, marginRight: "auto", marginLeft: "auto" }}
                  onToggle={(e, value) => this.setState({ masterScheduleActive: value }, () => this.handleUpdate())}
                />
                <Toggle
                  data-intercom-target={"menu-Schedules-ScheduleInfo-Toggle-MasterSchedule-AutoPost-As-Schedule-Planner"}
                  disabled={this.props.readonly}
                  label={strings.Post_as_Posted_Schedule}
                  toggled={!this.state.autoPostAsSchedulePlanner}
                  style={{ width: 200, marginTop: 5, marginRight: "auto", marginLeft: "auto" }}
                  onToggle={(e, value) => this.setState({ autoPostAsSchedulePlanner: !value }, () => this.handleUpdate())}
                />
                <TextField
                  data-intercom-target={"menu-Schedules-ScheduleInfo-Entry-PostScheduleInAdvanceDays"}
                  disabled={this.props.readonly}
                  floatingLabelText={strings.Post_Schedules_In_Advance_Days}
                  value={this.state.masterScheduleInAdvanceDays}
                  onChange={(e, value) => utils.validateInteger(value) && this.setState({ masterScheduleInAdvanceDays: value }, () => this.saveChanging())}
                  style={{ width: 150, marginTop: 10 }}
                  floatingLabelStyle={{ top: 30 }}
                  errorText={this.state.errorMasterScheduleInAdvanceDays}
                  errorStyle={{ position: "absolute", bottom: -10 }}
                />
                <div style={{ marginTop: 10 }}>{`${strings.Next_Post_Date}: ${moment(timeHelper.keepConvertUTCToLocal(this.props.schedule.NextPostDate)).format("MM/DD/YYYY")}`}</div>
                {showImmediatelyPostBtn &&
                  <RaisedButton
                    data-intercom-target={"master-schedule-Btn-PostImmediately"}
                    secondary
                    label={strings.Immediately_Post}
                    style={{ marginTop: 10 }}
                    onClick={this.props.handlePostMasterScheduleForCurrentWeek}
                  />
                }
              </div> :
              <div>
                <div style={{ fontSize: 15, marginTop: this.props.schedule.PublishInfo.Published ? 30 : 50 }}>
                  {periodDays > 1 && [
                    <span key="start">
                      {strings.From}: {moment(timeHelper.keepConvertUTCToLocal(this.props.schedule.StartDate)).format("ddd MMM. DD, YYYY")}
                    </span>,
                    <br key="br" />,
                    <span key="end">
                      {strings.To}: {moment(timeHelper.keepConvertUTCToLocal(this.props.schedule.EndDate)).format("ddd MMM. DD, YYYY")}
                    </span>
                  ]}
                </div>
                <div style={{ fontSize: 12, marginTop: 10 }}>{this.props.schedule.PublishInfo.Published && `${moment(this.props.schedule.PublishInfo.Date).format("ddd MMM. DD, YYYY hh:mm a")} by ${this.props.schedule.PublishInfo.PublishedByUserName}`}</div>
                <div style={{ fontSize: 15, fontWeight: 600, marginTop: 10 }}>{this.props.schedule.PublishInfo.Published ? strings.Posted_Schedule : strings.Schedule_Planner}</div>
                <div style={{ fontSize: 20, marginTop: 20 }}>
                  {periodDays === 1 ?
                    moment(timeHelper.keepConvertUTCToLocal(this.props.schedule.StartDate)).format("dddd MMM. DD, YYYY") :
                    periodDays === 7 ?
                      `1 ${strings.Week}` :
                      `${periodDays} ${strings.Days}`
                  }
                </div>
              </div>
            }
          </div>
          <div style={{ flex: 2, backgroundColor: grey100, position: "relative" }}>
            <div style={{ display: "flex", position: "absolute", right: 10, top: 10 }}>
              {!this.props.readonly &&
                !this.props.schedule.MasterSchedule &&
                !AppStateStore.hideScheduleAutoAssign &&
                !this.props.schedule.PublishInfo.Published &&
                permissionHelper.hasPermission(AuthenticationStore.Permissions.Schedule.EditSchedule) &&
                <div style={{ marginRight: 5, marginTop: 3 }}>
                  <i
                    data-intercom-target={"menu-Schedules-ScheduleInfo-Btn-OpenAutoAssignConfirmDialog"}
                    title={strings.Auto_Assign}
                    className="fa fa-magic"
                    style={{ fontSize: 19, color: grey800, cursor: "pointer" }}
                    onClick={this.props.handleAutoAssign}
                  />
                </div>
              }
              {(this.props.schedule.MasterSchedule || this.props.schedule.PublishInfo.Published) &&
                <div style={{ marginRight: 5, marginTop: 3 }}>
                  <i
                    data-intercom-target={"menu-Schedules-ScheduleInfo-Btn-DownloadScheduleReport"}
                    title={strings.Schedule_Report}
                    style={{ fontSize: 21, color: grey800, cursor: "pointer" }}
                    className="fa fa-download"
                    onClick={() => reportAction.downloadScheduleReport(this.props.schedule.Id)}
                  />
                </div>
              }
              {!this.props.readonly && permissionHelper.hasPermission(AuthenticationStore.Permissions.Schedule.AddSchedule) &&
                <div>
                  <IconButton
                    data-intercom-target={"menu-Schedules-ScheduleInfo-Btn-OpenCopyScheduleDialog"}
                    title={strings.Copy_Schedule}
                    onClick={this.props.handleCopySchedule}
                    style={{ padding: 0, height: 25, width: 25 }}
                  >
                    <Copy width={23} height={20} color={grey600} />
                  </IconButton>
                </div>
              }
            </div>
            <div style={{ padding: "15px 50px" }}>
              <div style={{ width: "75%" }}>
                <TextField
                  data-intercom-target={"menu-Schedules-ScheduleInfo-Entry-Name"}
                  floatingLabelText={strings.Name}
                  value={this.state.name}
                  onChange={(e, value) => { this.setState({ name: value }, () => this.saveChanging()) }}
                  errorText={this.state.errorName}
                  errorStyle={{ position: "absolute", bottom: -10 }}
                  fullWidth={true}
                  disabled={this.props.readonly || !permissionHelper.hasPermission(AuthenticationStore.Permissions.Schedule.EditSchedule)}
                />
              </div>
              <div style={{ width: "75%" }}>
                <TextField
                  data-intercom-target={"menu-Schedules-ScheduleInfo-Entry-Description"}
                  floatingLabelText={strings.Description}
                  value={this.state.description}
                  onChange={(e, value) => { this.setState({ description: value }, () => this.saveChanging()) }}
                  fullWidth={true}
                  disabled={this.props.readonly || !permissionHelper.hasPermission(AuthenticationStore.Permissions.Schedule.EditSchedule)}
                />
              </div>
              <Toggle
                data-intercom-target={"menu-Schedules-ScheduleInfo-Toggle-ExcludeWeekends"}
                label={strings.Exclude_Weekends}
                toggled={this.state.excludeWeekends}
                style={{ width: 225, marginTop: 25 }}
                onToggle={(e, value) => this.setState({ excludeWeekends: value }, () => this.handleUpdate())}
                disabled={this.props.readonly || !permissionHelper.hasPermission(AuthenticationStore.Permissions.Schedule.EditSchedule)}
              />
              <div style={{ marginTop: 20, display: "flex" }}>
                <ChooseHierarchyJobChip
                  readonly={this.props.readonly ||
                    !permissionHelper.hasPermission(AuthenticationStore.Permissions.Schedule.EditSchedule) ||
                    this.props.type === EScheduleListType.ClientSchedule ||
                    this.props.schedule.ClientId ? true : false
                  }
                  hideJob={!AccountStore.getJobsEnabled()}
                  hierarchyChipLabel={strings.HierarchyLevel}
                  jobChipLabel={checkJobFieldAvailable('singular') ? `${AccountStore.getCurrentAccountSettings().CustomFieldSettings.JobFieldLabels.SingularJobLabel}` : strings.Job}
                  hierarchyItemId={this.state.hierarchyId}
                  jobId={this.state.job ? this.state.job.Id : null}
                  hieararchyChipMaxWidth={700}
                  jobChipMaxWidth={700}
                  handleSelectHierarchyJob={(hierarchyId: string, job: IJobDocument) => this.setState({ hierarchyId, job }, () => this.handleUpdate())}
                />
                {AccountStore.getClientsEnabled() &&
                  <div style={{ marginLeft: 15 }}>
                    <ChooseClientChip
                      disabled={this.props.readonly || !permissionHelper.hasPermission(AuthenticationStore.Permissions.Schedule.EditSchedule)}
                      label={strings.Client}
                      selectedClient={this.state.client}
                      handleSave={client => this.setState({ client, hierarchyId: client ? client.HierarchyId : this.state.hierarchyId, job: null }, () => this.handleUpdate())}
                    />
                  </div>
                }
              </div>
            </div>
          </div>
          <div style={{ flex: 2 }}>
            <ScheduleBudgetDetail schedule={this.props.schedule} />
          </div>
        </div>
      </Paper >
    )
  }
}